var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBillingModalBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 288,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.058 0h225.328v288s8.718-23.998-39.566-100.318c-48.285-76.32-112.99-52.173-150.89-96.813C-2.971 46.229.058 0 .058 0z",
    fill: "url(#billing-modal-background_svg__paint0_linear_25783_206321)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "billing-modal-background_svg__paint0_linear_25783_206321",
    x1: 113,
    y1: 0,
    x2: 113,
    y2: 288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F8F8"
  })))));
}
export default SvgBillingModalBackground;